<template>
  <span>
    <el-button
      :loading="downloadLoading"
      style="margin:0 0 20px 20px;"
      type="primary"
      size="medium"
      icon="el-icon-document"
      @click="handleDownload"
    >
      导出身份信息表
    </el-button>
  </span>
</template>

<script>
export default {
  props: {
    search: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      downloadLoading: false,
      exportList: [],
      columns: [
        {
          title: "序号",
          value: "id",
        },
        {
          title: "是否已取得登记证照",
          value: "is_djzz",
        },
        {
          title: "名称（已取得登记证照）",
          value: "qddjzz.xm",
        },
        {
          title: "统一社会信用代码（纳税人识别号）（已取得登记证照）",
          value: "qddjzz.dp_idtyshxydm",
        },
        {
          title: "专业服务机构标识（已取得登记证照）",
          value: "qddjzz.zyfwjgbs",
        },
        {
          title: "姓名（未取得登记证照）",
          value: "wqddjzz.name",
        },
        {
          title: "证件类型（未取得登记证照）",
          value: "wqddjzz.zjlx",
        },
        {
          title: "证件号码（未取得登记证照）",
          value: "wqddjzz.zjhm",
        },
        {
          title: "国家或地区（未取得登记证照）",
          value: "wqddjzz.gj",
        },
        {
          title: "是否存在免于报送收入信息情形（未取得登记证照）",
          value: "wqddjzz.is_mybsxx",
        },
        {
          title: "免报类型（未取得登记证照）",
          value: "wqddjzz.mblx",
        },
        {
          title: "地址",
          value: "address",
        },
        {
          title: "店铺（用户）名称",
          value: "dp_name",
        },
        {
          title: "店铺（用户）唯一标识码",
          value: "dp_id",
        },
        {
          title: "网址链接（选填）",
          value: "url",
        },
        {
          title: "开户银行/非银行支付机构（结算（支付）账户信息（选填））",
          value: "jszhxx.khyh",
        },
        {
          title: "账户名称（结算（支付）账户信息（选填））",
          value: "jszhxx.zhmc",
        },
        {
          title: "银行账户/支付账号（结算（支付）账户信息（选填））",
          value: "jszhxx.yhzh",
        },
        {
          title: "联系人姓名",
          value: "lxrxm",
        },
        {
          title: "联系电话",
          value: "lxrdh",
        },
        {
          title: "经营开始时间",
          value: "jy_time",
        },
        {
          title: "经营结束时间",
          value: "jyjssj",
        },
        {
          title: "信息状态标识",
          value: "xxztbs",
        }
      ],
    };
  },
  created() {
    // let b = [];
    // for (let i in a) {
    //   b.push({ title: a[i].description, value: i });
    // }
    // console.log([b]);
  },
  methods: {
    async init(type) {
      let params = { ...this.search };
      if (type == "export") {
        params.current_page = 1;
        params.page_size = 99999999;
      } else {
        this.downloadLoading = true;
      }
      if (params.month) {
        params.month = params?.month.replace(/-/, "");
      }
      let {data} = await this.$api.getDeclareEmployeeExport(params);
      if (type == "export") {
        this.downloadLoading = false;
        return data;
      }
    },
    async handleDownload() {
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = this.columns.map((item) => item.title);
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `收入信息${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let tempArr = [];
        this.columns.map((item) => {
          if (item.value.indexOf(".") != "-1") {
            tempArr.push(eval(`v.${item.value}`));
          } else {
            tempArr.push(v[item.value]);
          }
        });
        return tempArr;
      });
    },
  },
};
</script>
<style scoped lang="stylus">
.selectWord
  width: 155px
.date-picker {
  margin-left: 10px;
  width: 250px;
}
.block {
  margin-right: 20px;
}
</style>
